export enum NavigationType {
  Feed = 'Feed',
  Category = 'Category',
}
